import { reservesConfig } from '../../../../config';
import { http } from '../../../../api/axios';
import { Pagination } from '../../../../../models/Pagination';
import { ProductOut } from '../../../../store/api';

export type ApiReserveCheckoutProductsResponse = {
    took: string | null;
    hits: ProductOut[];
    totalHits: number;
};

export const fetchReserveCheckoutProducts = (
    reserveListId: string,
    params: Pagination
): Promise<ApiReserveCheckoutProductsResponse> => {
    return http
        .post(reservesConfig().endpointReserveCheckoutProducts, undefined, {
            params,
            pathParams: {
                reserveListId
            }
        })
        .then(response => response.data);
};
